import React from "react"
import {languages} from "../locales/languages"
import {useLocale} from "../context/AppContext"

function renderTranslation(key, language, extra) {
  const dictionary = languages[language] || languages.en
  const rawText = dictionary[key] || key

  const parts = rawText.split(/(\n|\{\w+\}|(?<!\\)\\"|\{mt-\d+\}|\{mb-\d+\})/).map((part, index) => {
    if (part === "\n") {
      return <br key={index} />
    } else if (part.match(/\{mt-\d+\}/)) {
      const marginValue = part.slice(4, -1)
      return <div key={index} style={{marginTop: `${marginValue}px`}} />
    } else if (part.match(/\{mb-\d+\}/)) {
      const marginValue = part.slice(4, -1)
      return <div key={index} style={{marginBottom: `${marginValue}px`}} />
    } else if (part.match(/\{\w+\}/)) {
      const placeholder = part.slice(1, -1)
      const replacement = extra && extra[placeholder]
      return replacement !== undefined ? replacement : part
    } else if (part === '\\"') {
      return {type: "italic-toggle", key: index}
    }
    return part
  })

  const processedParts = []
  let italicMode = false

  parts.forEach((part, index) => {
    if (part && part.type === "italic-toggle") {
      italicMode = !italicMode
    } else if (italicMode && typeof part === "string") {
      processedParts.push(<i key={index}>{part}</i>)
    } else if (italicMode && React.isValidElement(part)) {
      processedParts.push(<i key={index}>{part}</i>)
    } else {
      processedParts.push(part)
    }
  })

  const isAnyPartJsx = processedParts.some(part => React.isValidElement(part))
  return isAnyPartJsx ? <>{processedParts}</> : processedParts.join("")
}

export function useTranslation() {
  const {language} = useLocale()
  return (key, extra) => renderTranslation(key, language, extra)
}

export default useTranslation
